/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoRadioButton implements angular.IDirective {
        restrict = "E";
        require = "ngModel";
        scope = {
            name: "@",
            id: "@",
            model: "=ngModel",
            change: "&?ngChange",
            value: "=ngValue",
            contentKey: "@",
            disabled: "=ngDisabled"
        };

        template = `
            <div class="meevo-checkbox-wrapper" id="{{contentKey + model + $parent.$index }}" ng-click="toggleValue()">
                <div class="meevo-checkbox">
                    <div ng-class="{ 'checked': model==value, 'unchecked': model!=value }"></div>
                </div>
                <label class="meevo-checkbox-label" translate="{{::contentKey}}"></label>
            </div>
        `;

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {

            scope.toggleValue = (): void => {
                if (!scope.disabled) {
                    if (scope.model != scope.value) {
                        scope.model = scope.value;
                        
                        if (scope.change) {
                            this.$timeout(function() {
                                scope.$eval(scope.change);
                            });

                        }
                    }
                }
            }
        };

        constructor(private $timeout: any) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout: any) => {
                return new MeevoRadioButton($timeout);
            };

            directive.$inject = ["$timeout"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoRadioButton", MeevoRadioButton.factory());
}